"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require("babel-runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require("babel-runtime/helpers/asyncToGenerator");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var raceAgainstTimeout = function () {
  var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(promise, timeoutMs, timeoutCallback) {
    var timeout, timeoutPromise;
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            timeout = void 0;
            timeoutPromise = new Promise(function (resolve, reject) {
              timeout = setTimeout(function () {
                var error = new Error("Timeout after " + timeoutMs + " ms");
                if (timeoutCallback) timeoutCallback();
                reject(error);
              }, timeoutMs);
            });
            _context.prev = 2;
            _context.next = 5;
            return Promise.race([promise, timeoutPromise]);

          case 5:
            return _context.abrupt("return", _context.sent);

          case 6:
            _context.prev = 6;

            clearTimeout(timeout);
            return _context.finish(6);

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this, [[2,, 6, 9]]);
  }));

  return function raceAgainstTimeout(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = raceAgainstTimeout;
//# sourceMappingURL=raceAgainstTimeout.js.map